/**
 *  PercentBar script file
**/
import filters from '@/filters/customFormatters'

export default {
  name: 'PercentBar',
  mixins: [filters],
  components: {},
  props: {
    title: {
      type: String,
      required: false
    },
    total: {
      type: [String, Number],
      default: 0,
      required: true
    },
    current: {
      type: [String, Number],
      default: 0,
      required: false
    },
    format: {
      type: Number,
      default: 0,
      required: false
    },
    background: {
      type: String,
      default: '#ffffff',
      required: false
    },
    symbol: {
      type: String,
      required: false
    },
    loading: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    calculateWidth (total, current) {
      return `${current / total * 100}%`
    }
  }
}
